import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { TitleService } from '../../core/services/title.service';

@Injectable({ providedIn: 'root' })
export class AdminReviewTitleResolver implements Resolve<string> {
  constructor(private title: TitleService) {}
  resolve(): string {
    const t = 'Admin Review';
    this.title.setTitle(t);
    return t;
  }
}
